import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { resolveListingLocalizedField } from '@/helpers/ListingData/ListingData';
import { useListingStore } from '@/store/modules/listing';

export function useListingLocalizedContent() {
  const { locale } = useI18n();
  const listingStore = useListingStore();

  const listingTitle = computed(() =>
    resolveListingLocalizedField(
      listingStore.listing,
      locale.value as HgSupportedLanguage,
      'title',
    ),
  );

  const listingDescription = computed(() =>
    resolveListingLocalizedField(
      listingStore.listing,
      locale.value as HgSupportedLanguage,
      'description',
    ),
  );

  return { listingTitle, listingDescription, locale };
}
